import type { VoucherForCampaignUserItemInput } from "@/lib/gql/__generated__/graphql";

import { InputImageWrapper } from "@/components/ui/input/image/parts/input-image-wrapper";

import { InputForm } from "./parts/input-form";
import { FormErrorMessage, FormItem } from "../../../../../../../../../../../ui/form/_base/form";

type Props = {
	onSetCampaignList: (props: VoucherForCampaignUserItemInput[]) => void;
	errorMessage: string | undefined;
};

export const CSVField = ({ onSetCampaignList, errorMessage }: Props): JSX.Element | null => {
	return (
		<FormItem>
			<InputImageWrapper>
				<InputForm onSetCampaignList={onSetCampaignList} />
			</InputImageWrapper>
			<FormErrorMessage>{errorMessage}</FormErrorMessage>
		</FormItem>
	);
};

CSVField.displayName = "CSVField";
